import React from 'react';
import { Link } from 'react-router-dom';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import FloatingButtons from './components/FloatingButtons';
import ScrollToTop from './components/ScrollToTop';

// Pages import karein
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import ServicesPage from './pages/ServicesPage';
import ServiceDetail from './pages/ServiceDetail';
import FAQPage from './pages/FAQPage';
import EnquiryPage from './pages/EnquiryPage';
import CabServices from './pages/CabServices';
import RealEstate from './pages/RealEstate';
import BusinessSetup from './pages/BusinessSetup';
import PackersMovers from './pages/PackersMovers';
import Registration from './pages/Registration';
import Compliance from './pages/Compliance';
import OrganicPyrolysis from './pages/OrganicPyrolysis';
import JLPTCourse from './pages/JLPTCourse';

function App() {
  return (
    <Router>
      <ScrollToTop />

      <Routes>

        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/services/:name" element={<ServiceDetail />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/enquiry" element={<EnquiryPage />} />
        <Route path="/cab-services" element={<CabServices />} />
        <Route path="/real-estate" element={<RealEstate />} />
        <Route path="/business-setup" element={<BusinessSetup />} />
        <Route path="/packers-movers" element={<PackersMovers />} />
        <Route path="/registration" element={<Registration />} />
        <Route path="/compliance" element={<Compliance />} />
        <Route path="/pyrolysis-system" element={<OrganicPyrolysis />} />
        <Route path="/jlpt-course" element={<JLPTCourse />} />

      </Routes>
      <FloatingButtons />
    </Router>
  );
}

export default App;